import {
  Select,
  SxProps,
  MenuItem,
  InputLabel,
  FormControl,
  OutlinedInput,
  SelectChangeEvent,
} from '@mui/material';

type Props = {
  label?: string;
  options: { label: string; value: string }[];
  sx?: SxProps;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
};

export default function FilterSingleSelect({ label, options, sx, value, onChange }: Props) {
  return (
    <FormControl
      sx={{
        flexShrink: 0,
        width: 1,
        ...sx,
        // width: { xs: 1, md: 180 },
      }}
    >
      <InputLabel>{label}</InputLabel>
      <Select input={<OutlinedInput label={label} />} value={value} onChange={onChange}>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
